import React from "react"
import {AssignedDetailType0, AssignedDetailType1} from "../components/tools/RequestDetail"
import {useParams} from "react-router-dom"
import Logout from "../components/Logout"



const AssignedDetailContent = () => {
    const {request_id} = useParams()
    const {request_type} = useParams()

    return (
        <>
            <Logout />
            {request_type === '0' && <AssignedDetailType0 request_id={request_id}/>}
            {request_type === '1' && <AssignedDetailType1 request_id={request_id}/>}
        </>
    )
}
export default AssignedDetailContent;